module.exports = __webpack_public_path__ + "static/media/Animalshealthbio.6788578b.jpeg";